import React, { useEffect, useState } from "react";
import Handler from "../../Helpers/Components/Handler";
import moment from "moment";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder"
import PageChanger from "../../Helpers/Components/Pagination1";
import { Link, useNavigate, useParams } from "react-router-dom";
import { DropdownButton, DropdownToggle } from "../../Helpers/Components/Dropdown";
import Modal from "../../Helpers/Components/Modal";
import { toast } from "react-toastify";
import { reloadWindow } from "../../Helpers/Utils";
import Select from 'react-select'

const Booking = () => {
    const [detail, setDetail] = useState([])
    const [loading, setLoading] = useState(false)
    const [pageNo, setPageNo] = useState(1)
    const [count, setCount] = useState(10)
    const [next, setNext] = useState(false)
    const [modal, showModal] = useState(false)
    const [cancel, setCancel] = useState({ booking: "", remarks: "" })
    const { customerId } = useParams()
    const [color, setColor] = useState(false)
    const navigate = useNavigate()
    const getDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: "post", url: `/booking/search/${pageNo}?count=${count || 10}`, data: { customerId, sortBy: "deliveryDetails.delivery", sort: true } })
        setLoading(false)
        if (response?.success) {
            setDetail(response?.data?.current)
            setNext(response?.data?.next)
        } else {
            setDetail([])
            setNext(false)
        }
    }
    const cancelBooking = async () => {
        if (!cancel?.remarks) {
            toast.error("Remarks is required")
        } else {
            setLoading(true)
            const response = await Handler({ method: "patch", url: `/booking/details/cancel/${cancel?.booking}`, data: { remarks: cancel?.remarks } })
            if (response?.success) {
                toast.success(response?.message)
                showModal(false)
                setTimeout(() => {
                    reloadWindow()
                    setLoading(false)
                }, 1500);
            } else {
                toast.error(response?.message)
                setLoading(false)
            }
        }
    }
    const checkDelivery = async (booking) => {
        const date = new Date(new Date(booking?.deliveryDetails?.delivery)?.setHours(0, 0, 0))
        const today = new Date()
        if (today >= date) {
            navigate(`/booking/delivery/${booking?.bookingId}`)
        } else {
            toast.error("Delivery can't be made")
        }
    }
    useEffect(() => {
        getDetails()
    }, [pageNo, count])
    return (
        <React.Fragment>
            <div className="my-3 p-3 card">
                <h5 className="text-center fw-bold text-theme">Booking</h5>
                <div className="d-flex align-items-center justify-content-center mt-3 gap-4">
                    <div className="form-check">
                        <input className="form-check-input" type="radio" name="radioDefault" id="backgroundColor" checked={color} onChange={(e) => { if (e.target.checked) { setColor(true) } }} />
                        <label className="form-check-label fw-medium" htmlFor="backgroundColor"> Background </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="radio" name="radioDefault" id="color" checked={!color} onChange={(e) => { if (e.target.checked) { setColor(false) } }} />
                        <label className="form-check-label fw-medium" htmlFor="color"> Color </label>
                    </div>
                </div>
                <div className="my-4 d-flex flex-wrap justify-content-center gap-3 align-items-center">
                    <div className="d-flex align-items-center gap-2"><span className={`${color ? "back-light-purple" : "light-purple"} booking-colors`}> B </span> Booked</div>
                    <div className="d-flex align-items-center gap-2"><span className={`${color ? "back-inactive" : "inactive"}  booking-colors`}>I</span> Inactive</div>
                    <div className="d-flex align-items-center gap-2"><span className={`${color ? "back-light-yellow" : "light-yellow"}  booking-colors`}>O</span> Ongoing</div>
                    <div className="d-flex align-items-center gap-2"><span className={`${color ? "back-cancel-red" : "cancel-red"} booking-colors`}>P</span> Pending</div>
                    <div className="d-flex align-items-center gap-2"><span className={`${color ? "back-pending-complete" : "pending-complete"} booking-colors`}>P</span> Pending & Completed</div>
                    {/* <div className="d-flex align-items-center gap-2"><span className={`${color ? "back-provision" : "provision"} booking-colors`}>E</span> Excess Damage </div> */}
                    <div className="d-flex align-items-center gap-2"><span className={`${color ? "back-completed" : "completed"} booking-colors`}>C</span> Completed</div>
                </div>
                <div className="overflow">
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr>
                                <th className="text-center rounded-start">S. No </th>
                                <th>Booking ID </th>
                                <th> Car ID  </th>
                                <th>Delivery Date </th>
                                <th>Pickup Date </th>
                                <th>Status</th>
                                <th className="text-center rounded-end">Action </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                loading ? <TablePlaceHolder count={7} /> :
                                    (detail?.length ? detail?.map((element, i) => {
                                        return (
                                            <tr key={i} id={i} className={`align-middle booking-table 
                                            ${color ?
                                                    (element?.carStatus === false && element?.status !== "Completed") || !element.customerStatus || element.customerKycStatus === "Unverified" ? "back-inactive" :
                                                        (element.status === "Booked" ? "back-light-purple" : (element.status === "Ongoing" ? "back-light-yellow" :
                                                            (element.status === "Pending" || element.status === "Cancelled" ? "back-cancel-red" :
                                                                (
                                                                    (element.pendingPhoto?.length > 0 ? "back-pending-complete" :

                                                                        (element.status === "Completed" ? "back-completed" : "")))
                                                            )))
                                                    : ""
                                                }`}>
                                                <td className="text-center">{i + 1}</td>
                                                <td>
                                                    <div className="d-flex flex-column">
                                                        <a href={`/booking/view/${element?.bookingId}`} className="booking-link">{element?.bookingId}</a>
                                                        <span className={`${color ? "text-black" : "provision"} fw-medium`}> {element?.excessProvision ? "Excess Charged" : ""}</span>
                                                    </div>
                                                </td>
                                                <td><a href={`/car/view/${element?.carId}`} className="booking-link">{element?.car || element?.carId || ""}</a> </td>
                                                <td>{element?.deliveryDetails?.delivery ? moment(element?.deliveryDetails?.delivery)?.format("DD-MM-YYYY hh:mm A") : ""}</td>
                                                <td>{element?.pickupDetails?.pickup ? moment(element?.pickupDetails?.pickup)?.format("DD-MM-YYYY hh:mm A") : ""}</td>
                                                <td className={`booking-cust-table ${(element?.carStatus === false && element?.status !== "Completed") || !element.customerStatus || element.customerKycStatus === "Unverified" ? "inactive" :
                                                    (element.status === "Booked" ? "light-purple" : (element.status === "Ongoing" ? "light-yellow" :
                                                        (element.status === "Pending" || element.status === "Cancelled" ? "cancel-red" :
                                                            ((element.pendingPhoto?.length > 0 ? "pending-complete" :
                                                                (element.status === "Completed" ? "completed" : ""))))))}`}>{element?.status || "-"}</td>
                                                <td className="text-center">
                                                    {
                                                        element?.bookingId ?
                                                            element?.status === "Cancelled" ? "-" :
                                                                element?.status === "Completed" ? <Link to={`/booking/invoice/${element?.bookingId}`} > Generate Bill </Link> :
                                                                    <>
                                                                        <DropdownToggle label={"Action"} className="dropdown-list-head">
                                                                            {
                                                                                element?.status === "Ongoing" || element?.status === "Pending" ?
                                                                                    <DropdownButton onClick={() => navigate(`/booking/close/${element?.bookingId}`)} className="list-btns list-success-btn" label="Pickup" />
                                                                                    : (element?.status === "Booked" && element?.carStatus) ?
                                                                                        <DropdownButton className="list-btns list-success-btn" label="Delivery" onClick={() => { checkDelivery(element) }} /> :
                                                                                        !element?.status ? <DropdownButton className="list-btns list-success-btn" label="Book" onClick={() => navigate(`/booking/update/${element?.bookingId}`)} /> : ""
                                                                            }
                                                                            {
                                                                                (element?.status === "Booked") ?
                                                                                    <DropdownButton label="Cancel" className="list-btns list-danger-btn" onClick={() => { setCancel({ booking: element?.bookingId, remarks: "" }); showModal(true) }} />
                                                                                    : element?.status === "Ongoing" ?
                                                                                        <DropdownButton label="Pending" className="list-btns list-danger-btn" onClick={() => navigate(`/booking/pending/${element?.bookingId}`)} />
                                                                                        : ""
                                                                            }
                                                                            {
                                                                                (element?.status === "Booked") ?
                                                                                    <DropdownButton label="Edit" className="list-btns list-warning-btn" onClick={() => navigate(`/booking/update/${element?.bookingId}`)} />
                                                                                    : element?.status === "Ongoing" ?
                                                                                        <DropdownButton label="Edit" className="list-btns list-warning-btn" onClick={() => navigate(`/booking/delivery/${element?.bookingId}`)} />
                                                                                        : ""
                                                                            }
                                                                        </DropdownToggle>
                                                                    </>
                                                            : <button className="btn btn-success btn-sm" onClick={() => navigate(`/booking/register`)}>Create Booking</button>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    }) : <tr><td colSpan={7} className="text-center">No Data Found</td></tr>)
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                    <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setCount(Number(selectedoption?.value))
                            setPageNo(1)
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={count ? { label: count, value: count } : { label: 10, value: 10 }}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} />
            </div>
            <Modal header={"Cancel Booking"} onShow={modal} toggle={() => showModal(false)} overlayToggle={() => showModal(false)}>
                Do you really wanna cancel the booking : {cancel?.booking}?
                <input placeholder="Remarks" autoComplete="off" className="form-control input-theme text-uppercase mt-3" onChange={(e) => setCancel((prev) => ({ ...prev, remarks: e.target.value }))} />
                <div className="pt-4 pb-2 text-center">
                    <button disabled={loading} className="btn btn-sm btn-danger" onClick={cancelBooking}>Cancel Booking</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default Booking